import React from "react";
import { Typography, Row, Col, Card } from "antd";
import "../styles/AboutUs.css";
const { Title, Paragraph } = Typography;

const AboutUs = () => {
  return (
    <div className="about-container">
      <div className="about-hero">
        <div className="about-hero-bg">
          <Title level={1}>About Us</Title>
          <Paragraph className="about-intro">
            JetSkill is an online learning platform where anyone can explore,
            purchase, and master a wide range of courses—from technology and
            business to design and personal development. Whether you're leveling
            up your career or learning something new for fun, JetSkill connects
            you with expert-led content anytime, anywhere. Join thousands of
            learners and start your journey today.
          </Paragraph>
        </div>
      </div>

      <Row gutter={[16, 16]} className="about-features">
        <Col xs={24} md={8}>
          <Card
            title="Trusted Mentors"
            bordered={false}
            cover={
              <img
                alt="Mentors"
                src="imgs/tool-making-mentoring-work-online.jpg"
              />
            }
          >
            <p style={{ fontSize: "16px" }}>
              Courses are taught by experts with many years of experience.
            </p>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            title="Learn Anytime, Anywhere"
            bordered={false}
            cover={<img alt="Device" src="imgs/Learn_everywhere.jpg" />}
          >
            <p style={{ fontSize: "16px" }}>
              Learners can access the course anytime on any device.
            </p>
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card
            title="Reputable Certifications"
            bordered={false}
            cover={
              <img
                alt="Certifications"
                src="imgs/make-an-online-course-certificate.jpg"
              />
            }
          >
            <p style={{ fontSize: "15px" }}>
              Receive a certificate upon completion of the course to mark your
              skill milestone.
            </p>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AboutUs;
